import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate, useLocation } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Location from "../Componants/profileSteps/Location";
import BasicsProfile from "../Componants/profileSteps/BasicsProfile";
import ContactInfo from "../Componants/profileSteps/ContactInfo";
import Portfolio from "../Componants/profileSteps/Portfolio";
import Accreditations from "../Componants/profileSteps/Accreditations";
import Employees from "../Componants/profileSteps/Employees";
import useVendorDetails from "../hooks/VendorDetails";

export default function MyProfile() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get the eventKey from the query parameter (if available)
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get("tab") || "first"; // Default to 'first' tab if no query param is found

  const { data, isLoading, refresh } = useVendorDetails();

  const handleTabSelect = (eventKey) => {
    // Update the URL with the selected tab's eventKey as a query param
    navigate(`?tab=${eventKey}`);
  };

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>My Profile</h4>
                  </div>
                  <Tab.Container
                    id="left-tabs-example"
                    activeKey={activeTab}
                    onSelect={handleTabSelect}
                  >
                    <Row className="my-profile-switch">
                      <Col sm={12}>
                        <Nav variant="pills" className="">
                          <Nav.Item>
                            <Nav.Link eventKey="first">Basics</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="second">Location</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="third">Contact Info</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="fourth">Portfolio</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="fifth">Accreditations</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="sixth">Employees</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </Col>
                      <Col sm={12}>
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <BasicsProfile data={data} refresh={refresh} />
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <Location data={data} />
                          </Tab.Pane>
                          <Tab.Pane eventKey="third">
                            <ContactInfo data={data} refresh={refresh} />
                          </Tab.Pane>
                          <Tab.Pane eventKey="fourth">
                            <Portfolio />
                          </Tab.Pane>
                          <Tab.Pane eventKey="fifth">
                            <Accreditations />
                          </Tab.Pane>
                          <Tab.Pane eventKey="sixth">
                            <Employees />
                          </Tab.Pane>
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>
                </div>
              </Col>
              <Col lg={4} className="mt-lg-0 mt-4">
                <div className="my-profile-complete">
                  <p>{data?.percentage ? data?.percentage : 0} Complete</p>
                  <ProgressBar now={data?.percentage ? data?.percentage : 0} />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
